import React from 'react';
import PropTypes from 'prop-types';

import { FormFieldContext, FormTextField, Stack } from '@metarouter-private/mr-mui';

import FormCodeEditor from 'app/components/form/FormCodeEditor';
import jsonObject from 'app/shared/form/validation/jsonObject';
import CenteredLoader from 'app/components/CenteredLoader';

import useValidateUniqueName from './useValidateUniqueName';

const NAME_FIELD_PROPS = {
  label: 'Name',
  name: 'name',
  required: true,
};

const DESCRIPTION_FIELD_PROPS = {
  label: 'Description',
  name: 'description',
};

const EVENT_JSON_FIELD_PROPS = {
  label: 'Event JSON',
  name: 'eventJson',
  required: true,
};

// NOTE: Must be used within one of the `mr-mui` form components (eg. `Form` or `FormModal`)
export default function SampleEventForm({ defaultValues }) {
  const { name, description, eventJson } = defaultValues ?? {};

  const { validateUniqueName, existingNamesLoading } = useValidateUniqueName({ sampleEventName: name });

  if (existingNamesLoading) {
    return <CenteredLoader />;
  }

  return (
    <Stack spacing={2} pt={1}>
      <FormFieldContext {...NAME_FIELD_PROPS} defaultValue={name} rules={{ validate: validateUniqueName }}>
        <FormTextField variant="outlined" />
      </FormFieldContext>

      <FormFieldContext {...DESCRIPTION_FIELD_PROPS} defaultValue={description}>
        <FormTextField variant="outlined" />
      </FormFieldContext>

      <FormFieldContext {...EVENT_JSON_FIELD_PROPS} defaultValue={eventJson} rules={{ validate: jsonObject }}>
        <FormCodeEditor foldable lang="json" />
      </FormFieldContext>
    </Stack>
  );
}

SampleEventForm.propTypes = {
  defaultValues: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    eventJson: PropTypes.string,
  }),
};
